function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.2238 9.1392C18.9309 9.43209 18.9309 9.90697 19.2238 10.1999L23.2718 14.2478H5.86305C5.47073 14.2478 5.15169 14.5616 5.14322 14.9519C5.14194 14.9698 5.1413 14.9878 5.1413 15.006V22.1372V22.7955V22.7972C5.1413 23.2114 5.47708 23.5472 5.8913 23.5472H11.4645C11.8787 23.5472 12.2145 23.2114 12.2145 22.7972V22.1372C12.2145 21.723 11.8787 21.3872 11.4645 21.3872H7.3013V16.4185H23.2718L19.2238 20.4666C18.9309 20.7595 18.9309 21.2343 19.2238 21.5272L19.6905 21.9939C19.9834 22.2868 20.4582 22.2868 20.7511 21.9939L26.8655 15.8796C27.016 15.729 27.0892 15.5304 27.085 15.3332C27.0892 15.1359 27.016 14.9374 26.8655 14.7868L20.7511 8.67251C20.4582 8.37961 19.9834 8.37961 19.6905 8.6725L19.2238 9.1392Z"
});

var SvgNext = function SvgNext(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNext, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Next.58e2e65c.svg";
export { ForwardRef as ReactComponent };